import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import PageHeader from '../../components/ui/PageHeader';
import LoadingScreen from '../../components/ui/LoadingScreen';
import { IconBuilding, IconChevronRight } from '../../components/ui/Icons';
import { useAuth } from '../../contexts/AuthContext';
import { usePortal } from '../../contexts/PortalContext';
import { useToast } from '../../contexts/ToastContext';
import { copyText, normalizeHost } from '../../utils/portalMode';

function PartnerDashboard() {
  const { admin } = useAuth();
  const { partnerPortalHost } = usePortal();
  const toast = useToast();
  const [stats, setStats] = useState({ customers: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      try {
        const response = await api.post('/partner/customers/list', { page: 1, limit: 1 });
        setStats({
          customers: response.data.data?.pagination?.total ?? (response.data.data?.tenants || []).length,
        });
      } catch {
        setStats({ customers: 0 });
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  if (loading) {
    return <LoadingScreen message="Loading dashboard..." />;
  }

  const brandName = admin?.tenant?.brand?.appName || admin?.tenant?.name || 'Partner';
  const buildPartnerSignupLink = () => {
    const host = normalizeHost(partnerPortalHost || window.location.hostname);
    const parts = host.split('.');
    const baseHost = parts[0] === 'partner' ? parts.slice(1).join('.') : host;
    const protocol = baseHost.includes('localhost') ? 'http' : 'https';
    return `${protocol}://${baseHost}/signup?partnerTenantId=${encodeURIComponent(admin?.tenant?._id || admin?.tenant?.tenantId || '')}&mode=partner_new_customer`;
  };

  const handleCopySignupLink = async () => {
    const ok = await copyText(buildPartnerSignupLink());
    if (ok) {
      toast.success('Partner signup link copied');
    } else {
      toast.error('Failed to copy partner signup link');
    }
  };

  return (
    <div className="page">
      <PageHeader
        title={`${brandName} portal`}
        description="Create customer workspaces, manage your brand, and see who bills whom."
      />
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-card__icon stat-card__icon--rose">
            <IconBuilding width={22} height={22} />
          </div>
          <div>
            <div className="stat-card__value">{stats.customers}</div>
            <div className="stat-card__label">Customers</div>
          </div>
        </div>
      </div>
      <h2 className="section-title">Quick actions</h2>
      <div className="quick-links">
        <button type="button" className="quick-link" onClick={handleCopySignupLink}>
          Copy signup link <IconChevronRight width={16} height={16} />
        </button>
        <Link to="/customers" className="quick-link">
          Customers <IconChevronRight width={16} height={16} />
        </Link>
        <Link to="/brand" className="quick-link">
          Brand <IconChevronRight width={16} height={16} />
        </Link>
        <Link to="/usage" className="quick-link">
          Billing & usage <IconChevronRight width={16} height={16} />
        </Link>
      </div>
    </div>
  );
}

export default PartnerDashboard;
